import React from 'react';
import { ListItem, ListItemContent, Box } from "@mui/joy";
import { Button } from '../Button';

import { Tag } from '../Snippet';
import { useTranslation } from 'react-i18next'
import { Icon } from '../../assets';
import { useFormatter } from '../../utils';
import { Anchor } from '../Typography';
import { isDocumentMediaPath } from 'src/mtska-frontend-data-provider/redux/downloadDocumentMedia';
import { resolvePublicMediaUrl, useResolvedMediaSrc } from 'src/mtska-frontend-data-provider/hooks/useResolvedMediaSrc';

const RelationshipFileGeneric = ({ k, v, editing, detailInspector = true, handleItemDetail, handleItemRemove, loadingDissociation }) => {
    const { t } = useTranslation();
    const { formatBytes, formatDate } = useFormatter();

    const printableExtensions = ['JPG', 'JPEG', 'PNG', 'SVG', 'WEBP'];
    const isPrintable = () => {
        const ucExtension = v?.extension && v?.extension.toUpperCase();
        return printableExtensions.includes(ucExtension);
    }

    const mediaUrl = v?.url && isDocumentMediaPath(v.url) ? v.url : null;
    const { src, ready, loading: mediaLoading, isMediaPath, downloadHref } = useResolvedMediaSrc(mediaUrl);

    const previewSrc = isPrintable() && v?.url
        ? (isMediaPath ? (ready ? src : null) : resolvePublicMediaUrl(v.url))
        : null;

    const fileDownloadHref = isMediaPath && downloadHref
        ? downloadHref
        : (v?.url ? resolvePublicMediaUrl(v.url) : null);

    return (
        <ListItem key={k} variant="outlined" className={"relationship-element"}>
            <ListItemContent className={"relationship-element-content"}>
                <Box className={"icon-file icon-" + (isPrintable() ? 'preview' : 'type')}>
                    {
                        isPrintable() && previewSrc && (
                            <img src={previewSrc} className="filepreview" alt="" />
                        )
                    }
                    {
                        isPrintable() && mediaLoading && (
                            <Icon icon="faFile" className="fileicon" />
                        )
                    }
                    {
                        !isPrintable() && (
                            <>
                                <Icon icon="faFile" className="fileicon" />
                                <Box className="extension">{v?.extension}</Box>
                            </>
                        )
                    }
                </Box>
                <Box className="coupled meta">
                    {
                        v.filename ? (
                            <>
                                <span className="label">{v?.filename}</span>
                                <span className="value">{v?.size ? formatBytes(v?.size / 1024) : '-'}</span>
                            </>
                        ) : (
                            <Tag color={"danger"} title={t("Missing")}>{t('Missing file')}</Tag>
                        )
                    }
                </Box>
                <Box className="type">{t(v?.type)}</Box>
                {
                    (v?.documentIdentifier != undefined || v?.documentIssuer != undefined) && (
                        <Box className="coupled issuer">
                            <span className="label"><Icon icon="faFingerprint" />{v?.documentIdentifier}</span>
                            <span className="value"><Icon icon="faLocationPin" />{v?.documentIssuer}</span>
                        </Box>
                    )
                }
                {
                    (v?.valid_at != undefined || v?.expire_at != undefined) && (
                        <Box className="coupled validity">
                            <span className="label"><Icon icon="faCalendarXmark" />{formatDate(v?.expire_at)}</span>
                            <span className="value"><Icon icon="faCalendarHeart" />{formatDate(v?.valid_at)}</span>
                        </Box>
                    )
                }
                {
                    (!editing) && fileDownloadHref && (
                        <Box className="coupled download">
                            <Anchor href={fileDownloadHref} target="_blank" level="body-small" icon="faDownload" className={"download_document"}>{t('Download')}</Anchor>
                        </Box>
                    )
                }
            </ListItemContent>

            {editing && handleItemDetail && detailInspector && (<Button onClick={() => handleItemDetail(v)} icon="faPen" variant="plain" />)}
            {(editing && handleItemRemove) && (<Button onClick={() => handleItemRemove(v)} icon="faClose" variant="plain" loading={loadingDissociation} />)}
        </ListItem>
    )
}

export default RelationshipFileGeneric
